import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { Users, Shield, GitBranch, Mail, Settings, ArrowLeft, LayoutDashboard } from 'lucide-react';

const adminNav = [
  { path: '/admin/users', icon: Users, label: 'Users' },
  { path: '/admin/roles', icon: Shield, label: 'Roles' },
  { path: '/admin/stages', icon: GitBranch, label: 'Lead Stages' },
  { path: '/admin/notifications', icon: Mail, label: 'Notifications' },
  { path: '/admin/settings', icon: Settings, label: 'System Settings' },
];

export default function AdminLayout() {
  const location = useLocation();

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <NavLink to="/" className="flex items-center gap-2 px-3 py-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors">
          <ArrowLeft className="w-4 h-4" />
          Back to Dashboard
        </NavLink>
        <h1 className="text-2xl font-bold text-gray-900">Admin Panel</h1>
      </div>

      <div className="flex gap-6">
        {/* Admin Sidebar */}
        <div className="w-64 flex-shrink-0">
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 sticky top-6">
            <nav className="space-y-1">
              {adminNav.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  className={({ isActive }) => `
                    flex items-center gap-3 px-4 py-3 rounded-lg transition-all
                    ${isActive ? 'bg-indigo-50 text-indigo-600 font-medium' : 'text-gray-600 hover:bg-gray-50'}
                  `}
                >
                  <item.icon className="w-5 h-5" />
                  <span>{item.label}</span>
                </NavLink>
              ))}
            </nav>
          </div>
        </div>

        {/* Admin Content */}
        <div className="flex-1 min-w-0">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
